module.exports = __webpack_public_path__ + "img/tk-back.c2ec04e3.png";